<template>
  <div :class="$style.mapWrapper">
    <lv-grid type="row" wrap="wrap">
      <lv-grid type="item" xs="1/1">
        <lv-heading tag="h1" level="4">
          {{ $awt('aw.map.delivery.food.main.title') }}
        </lv-heading>
        <p :class="$style.desc">
          {{ $awt('aw.map.delivery.food.main.desc') }}
        </p>
      </lv-grid>
    </lv-grid>
    <div :class="$style.mapContainer">
      <lv-grid type="row" wrap="wrap">
        <lv-grid type="item" xs="1/1" md="1/3">
          <lv-heading tag="h2" level="3" regular>
            {{ title || $awt('aw.map.delivery.food.title') }}
          </lv-heading>
          <div :class="$style.desc">
            <p v-if="!postcodes.length">
              {{ $awt('aw.map.delivery.food.desc') }}
            </p>
            <template v-else>
              <ul v-if="isActive" :class="$style.postcodeList">
                <li v-for="pc in postcodes" :key="pc" :class="$style.postcodeItem">
                  {{ pc }} - {{ title }}
                  <lv-button
                    styling="primary"
                    shrink
                    :disabled="pc === selectedPostcode"
                    @click="setPostcode(pc)"
                  >
                    {{ $awt(pc === selectedPostcode ? 'aw.map.delivery.food.selected' : 'aw.map.delivery.food.select') }}
                  </lv-button>
                </li>
              </ul>
              <template v-else>
                <p :class="$style.desc">
                  {{ $awt('aw.map.delivery.food.newsletter.title') }}
                </p>
              </template>
            </template>
          </div>
          <lv-button
            v-if="shopAreaId !== ''"
            shrink
            styling="link-primary"
            :class="$style.back"
            @click="shopAreaId = ''"
          >
            {{ $awt('aw.map.delivery.food.back') }}
          </lv-button>
        </lv-grid>
        <lv-grid type="item" xs="1/1" md="2/3">
          <aw-auchan-shop-area-map v-model="shopAreaId" @change="onChange" />
        </lv-grid>
      </lv-grid>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import { LvGrid, LvHeading, LvButton } from '~~/common/components/loginet-vue-shop/index';
  import AwAuchanShopAreaMap from '~~/shop/app/components/Common/Map/AwAuchanShopAreaMap';
  import { DELIVERY_AREA_MODEL } from '~~/shop/app/config/DeliveryMethodConfig';
  import { useNotificationStore } from '~~/common/stores/notification';
  import { useDeliveryStore } from '~~/shop/app/stores/delivery';

  export default {
    name: 'AwAuchanShopAreaMapContext',
    components: {
      AwAuchanShopAreaMap,
      LvGrid,
      LvHeading,
      LvButton,
    },
    data () {
      return {
        shopAreaId: '',
        title: '',
        isActive: false,
        postcodes: [],
      };
    },
    computed: {
      ...mapState(useDeliveryStore, {
        selectedPostcode: state => state.setup?.postCode,
      }),
    },
    methods: {
      onChange ({
        postcodes,
        title,
        isActive,
      }) {
        this.title = title;
        this.postcodes = postcodes;
        this.isActive = isActive;
      },
      async setPostcode (pc) {
        const deliveryStore = useDeliveryStore();
        const response = await this.$api.$get('/public_areas', {
          params: {
            page: 1,
            post_code: pc,
          },
        });
        let areaId;
        if (response.length > 1) {
          this.$logger.warn(`SVG map: Guessing areaId from postCode: ${pc} and title ${this.title}.`);
          const guess = response.filter(({ settlementName }) => settlementName.includes(this.title));
          if (guess.length > 1) {
            this.$logger.warn(`SVG map: Exact guess is unsuccessfull for ${pc} and ${this.title}.`);
          } else if (guess.length === 0) {
            this.$logger.warn(`SVG map: Too strict guess for ${pc} and ${this.title}.`);
          }
          areaId = (guess[0] || response[0]).id;
        } else if (response.length === 1) {
          areaId = response[0].id;
        } else {
          const notificationStore = useNotificationStore();
          notificationStore.pushError({
            text: {
              titleToken: 'aw.map.delivery.food.area_not_found',
            },
          });
          return;
        }
        await deliveryStore.pushMethod({
          type: DELIVERY_AREA_MODEL.PUBLIC_AREA,
          areaId: parseInt(areaId),
        });
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.map {
  &Wrapper {
    display: flex;
    flex-direction: column;
  }

  &Container {
    position: relative;
    flex-grow: 1;
    padding: 45px 20px 20px;
    background: #E6E6E6;

    &::before {
      position: absolute;
      top: 0;
      content: "";
      transform: translateX(100%);
      border-width: 25px 25px 0;
      border-style: solid;
      border-color: $color-seashell transparent transparent;
    }
  }
}

.postcode {
  &List {
    display: grid;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
    list-style-type: none;
    gap: 6px;
  }

  &Item {
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    gap: 1em;
  }
}

.desc {
  line-height: 23px;
  margin: 10px 0;
  color: $color-silver-chalice;
}

.back {
  margin-bottom: 18px;
}
</style>
